import { Card, Typography } from "@mui/material"
import React, { ChangeEvent } from "react"
import { theme } from "../../../../../../../theme"
import { FormNumberInput } from "../../../../../../components/inputs/number-input/FormNumberInput"
import { FormMultilineTextInput } from "../../../../../../components/inputs/text-input/FormMultilineTextInput"

interface IProps {
  title?: string
  fieldName?: string
  id?: string
  label: string
  subTitle?: string
  form: Record<string, any>
  errors: Record<string, string | undefined>
  required?: boolean
  content?: React.JSX.Element

  handleChange(event: ChangeEvent<HTMLInputElement>): void
}

export function BSVariantFormCard({
  title,
  fieldName,
  id,
  label,
  subTitle,
  form,
  errors,
  handleChange,
  required = false,
  content,
}: Readonly<IProps>): React.JSX.Element {
  return (
    <Card
      sx={{
        backgroundColor: theme.palette.common.white,
        borderRadius: 3,
        p: 3,
        mb: 3,
        boxShadow: "2px 4px 20px 0px rgba(0, 0, 0, 0.05)",
      }}>
      {title && (
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {title}
        </Typography>
      )}

      {subTitle && <Typography variant="body2">{subTitle}</Typography>}

      {fieldName && (
        <FormMultilineTextInput
          fieldName={fieldName}
          label={label}
          form={form}
          errors={errors}
          handleChange={handleChange}
          required={required}
        />
      )}

      {id && <FormNumberInput fieldName={id} label={label} errors={errors} form={form} handleEventChange={handleChange} />}

      {content}
    </Card>
  )
}
